import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';
import Rails from '@rails/ujs';
import '../channels';

const application = Application.start();
const controllers = import.meta.globEager('./**/*_controller.js');
registerControllers(application, controllers);
window.Rails = Rails;
